export enum StorageKeyEnum {
  PROFILE = 'A',
  TOKEN = 'B',
  PRODUCER = 'C',
}
